import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { MARCAS_LISTA } from 'constants/codigosTransacciones'

import ListaPage from './lista'

export default function MarcasPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${MARCAS_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
